import React from 'react';
import { NumericFormat } from 'react-number-format';
import { EXPEDIENT_TYPE_LABELS } from '@claimup/shared/constants/expedient';

const ExpedientListItem = ({ expedient, isSelected, onClick }) => {
  const importeDeudaFormatted = expedient.importe_deuda / 1;
  const debtorName =
    expedient.deudores && expedient.deudores.length > 0 ? expedient.deudores[0].debtorname : 'Sin deudor';

  // Format client name with 15 character limit
  const clientName = expedient?.nombre_comercial || 'Sin cliente';
  const formattedClientName = clientName.length > 15 ? clientName.substring(0, 15) + '.' : clientName;

  return (
    <div
      onClick={onClick}
      className={`
        p-3 py-2 border-b border-slate-200 cursor-pointer transition-colors
        ${isSelected ? 'bg-blue-50 border-l-4 border-l-blue-600' : 'hover:bg-slate-50'}
      `}
    >
      <div className='flex items-start gap-3'>
        {/* Content */}
        <div className='flex-1 min-w-0'>
          <div className='flex items-start justify-between gap-2 mb-1'>
            <h3 className='font-semibold text-slate-900 truncate'>{debtorName}</h3>
            {expedient.type && (
              <span className='shrink-0 px-2 py-0.5 text-[10px] font-semibold rounded-full bg-slate-100 text-slate-600'>
                {EXPEDIENT_TYPE_LABELS[expedient.type] || expedient.type}
              </span>
            )}
          </div>

          <div className='text-sm text-slate-600 mb-1 flex items-center gap-2'>
            <div>{formattedClientName}</div>
            <NumericFormat
              value={importeDeudaFormatted}
              displayType={'text'}
              thousandSeparator={'.'}
              decimalSeparator={','}
              suffix={' €'}
              decimalScale={2}
              className='ml-auto'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpedientListItem;
